module.exports = __webpack_public_path__ + "static/8153-8a7cc4fbd4b29f2300b7121186e72fab.jpg";